import type { ApolloClient } from '@apollo/client';

import { createSessionExpiredError } from '@/adapters/auth/tokenRefreshManager';
import type { TokenRefreshResult } from '@/adapters/auth/tokenRefreshManager';
import { hasUnauthenticatedError } from '@/adapters/graphql/unauthenticatedError';
import { ExchangeRefreshTokenDocument } from '@/generated/usermobile-bff/graphql';

const createRefreshTokenExchanger =
  (client: Pick<ApolloClient, 'mutate'>) =>
  async (refreshToken: string): Promise<TokenRefreshResult> => {
    try {
      const { data } = await client.mutate({
        mutation: ExchangeRefreshTokenDocument,
        variables: { input: { refreshToken } },
      });

      if (!data) {
        throw new Error('Token refresh failed: no data returned');
      }

      return data.exchangeRefreshToken;
    } catch (error) {
      if (hasUnauthenticatedError(error)) {
        throw createSessionExpiredError();
      }

      throw error;
    }
  };

export { createRefreshTokenExchanger };
